import Vue from 'vue'
import {firestorePlugin} from 'vuefire'
import firebase from 'firebase/app';
import 'firebase/firestore';

Vue.use(firestorePlugin)

const firebaseApp = firebase.initializeApp({
  apiKey: $("#FIREBASE_CHAT_API_KEY").val() || ' ',
  authDomain: $("#FIREBASE_CHAT_AUTH_DOMAIN").val() || ' ',
  databaseURL: $("#FIREBASE_CHAT_DATABASE_URL").val() || ' ',
  projectId: $("#FIREBASE_CHAT_PROJECT_ID").val() || ' ',
  storageBucket: $("#FIREBASE_CHAT_STORAGE_BUCKET").val() || ' ',
  messagingSenderId: $("#FIREBASE_CHAT_MESSAGING_SENDER_ID").val() || ' ',
  appId: $("#FIREBASE_CHAT_APP_ID").val() || ' ',
  measurementId: $("#FIREBASE_CHAT_MEASUREMENT_ID").val() || ' '
});

export const db = firebaseApp.firestore();
